import React from 'react';
import { Star } from 'lucide-react';

/**
 * Pink "Founding Member" star pill. Awarded to the first 500 non-seed users
 * to register. Used on Browse cards, profile detail, AI Match card, and Chat header.
 * Pass `size="sm"` for the tiny corner version, default is full pill with text.
 */
const FoundingMemberBadge = ({ size = 'md', className = '' }) => {
  if (size === 'sm') {
    return (
      <span
        title="Founding Member — one of Flirty's first 500"
        data-testid="founding-badge-sm"
        className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-gradient-to-br from-fnl-pink to-fuchsia-500 border-2 border-fnl-dark shadow-lg ${className}`}
      >
        <Star className="w-2.5 h-2.5 text-white fill-white" />
      </span>
    );
  }
  return (
    <span
      title="Founding Member — one of Flirty's first 500"
      data-testid="founding-badge"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-fnl-pink to-fuchsia-500 text-white text-[10px] font-bold uppercase tracking-wider shadow-[0_2px_8px_rgba(238,42,123,0.4)] ${className}`}
    >
      <Star className="w-3 h-3 fill-white" />Founding Member
    </span>
  );
};

export default FoundingMemberBadge;
